import _ from 'underscore';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import SimpleGrid from 'components/SimpleGrid';
import SizeDependedBlock from 'components/SizeDependedBlock';
import SlideSection from 'components/SlideSection';

import CommonPropTypes from 'utils/propTypes/common';

const MultirowSlideSection = ({
	gridSize,
	direction,
	onCardClick,
	CardComponent,
	cardParams,
	isRowOnMobile,
	...props
}) => {
	const renderCards = useCallback(
		(items) =>
			_(items).map((item) => (
				<CardComponent
					key={item._id}
					data={item}
					markupAttributes={props.markupBlocks.cards}
					{...cardParams}
				/>
			)),
		[cardParams, onCardClick, props.markupBlocks.cards]
	);

	const renderBlockSlides = useCallback(
		(items) => {
			const blocks = _(items).chunk(gridSize);

			return _(blocks).map((block, index) => (
				// eslint-disable-next-line react/no-array-index-key
				<SimpleGrid key={index} direction={direction}>
					{renderCards(block)}
				</SimpleGrid>
			));
		},
		[renderCards, gridSize, direction]
	);

	const renderSection = useCallback(
		(renderSlides, slidesPerView) => (
			<SlideSection {...props} slidesPerView={slidesPerView}>
				{renderSlides(props.items || [])}
			</SlideSection>
		),
		[props]
	);

	return isRowOnMobile ? (
		<SizeDependedBlock>
			{renderSection(renderCards)}
			{renderSection(renderBlockSlides, props.slidesPerView)}
		</SizeDependedBlock>
	) : (
		renderSection(renderBlockSlides, props.slidesPerView)
	);
};

MultirowSlideSection.propTypes = {
	items: CommonPropTypes.entities,
	cardParams: PropTypes.object,
	CardComponent: PropTypes.func.isRequired,
	onCardClick: PropTypes.func,
	slidesPerView: PropTypes.number,
	direction: PropTypes.string,
	gridSize: PropTypes.number,
	isRowOnMobile: PropTypes.bool,
	markupBlocks: PropTypes.object
};

MultirowSlideSection.defaultProps = {
	items: [],
	gridSize: 1,
	markupBlocks: {}
};

export default MultirowSlideSection;
